module.exports = __webpack_public_path__ + "img/p003.368d643c.png";